import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';

import { XmlVsElementsComponent } from './xml-vs-elements/xml-vs-elements.component';
import { EfileSoftwareDataCreateEditComponent } from './efile-software-data-create-edit/efile-software-data-create-edit.component';
import { EfileAdditionalElementsComponent } from './efile-additional-elements/efile-additional-elements.component';
import { BulkXmlSyncComponent } from './bulk-xml-sync/bulk-xml-sync.component';
import { EfileAddEditObjectComponent } from './efile-add-edit-object/efile-add-edit-object.component';
import { EfilePropertiesComponent } from './efile-properties/efile-properties.component';
import { EfileSchemaSetComponent } from './efile-schema-set/efile-schema-set.component';
import { EfileDataDefinitionComponent } from './efile-data-definition/efile-data-definition.component';
import { EfileTmefConfigComponent } from './efile-tmef-config/efile-tmef-config.component';
import { EfileTmefEntityMapComponent } from './efile-tmef-entity-map/efile-tmef-entity-map.component';
import { EfileAddEditDiagnosticsComponent } from './efile-add-edit-diagnostics/efile-add-edit-diagnostics.component';
import { EfileIrsSubmissionComponent } from './efile-irs-submission/efile-irs-submission.component';

const allComponents = [
  XmlVsElementsComponent,
  EfileSoftwareDataCreateEditComponent,
  EfileAdditionalElementsComponent,
  BulkXmlSyncComponent,
  EfileAddEditObjectComponent,
  EfilePropertiesComponent,
  EfileSchemaSetComponent,
  EfileDataDefinitionComponent,
  EfileTmefConfigComponent,
  EfileTmefEntityMapComponent,
  EfileAddEditDiagnosticsComponent,
  EfileIrsSubmissionComponent
];

@NgModule({
  declarations: allComponents,
  imports: [
    CommonModule,
    FormsModule,
    SharedComponentsModule
  ],
  exports: allComponents
})
export class AdminservicesModule { }
